import { CONTROLLER_NAMES } from "../../../data/Constant";

export const Menu = [
    {
        id: [CONTROLLER_NAMES.User ,CONTROLLER_NAMES.Roles],
        icon: "solar:users-group-two-rounded-bold",
        name: "usersManagement",
        path: "/usersManagement",
        children: [{
            id: CONTROLLER_NAMES.User,
            icon: "fa-user-shield",
            path: "/users",
            name: "Users"
        },
        {
            id: CONTROLLER_NAMES.Roles,
            icon: "fa-user-tag",
            path: "/roles",
            name: "Roles"
        }]
    },
   // {
   //     id: [CONTROLLER_NAMES.ServiceCategory],
   //     icon: "ri:service-line",
   //     path: "/service-category",
   //     name: "ServiceCategory",
   // },
   // {
   //     id: [CONTROLLER_NAMES.Transactions],
   //     icon: "solar:wallet-money-bold",
   //     path: "/transactions",
   //     name: "transactions",
   // },
    {
        id: [CONTROLLER_NAMES.ProviderRegistrationRequest],
        icon: "mdi:partnership-outline",
        path: "/providers-request",
        name: "providers-request",
    },
    {
        id: [CONTROLLER_NAMES.MedicalOrder],
        icon: "healthicons:virus-patient",
        path: "/medical-users-requests",
        name: "medical-users-requests",
    },
    {
        id: [CONTROLLER_NAMES.HospitalProfile],
        icon: "healthicons:virus-patient",
        path: "/provider-profile",
        name: "provider-profile",
    },
]